
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { Model, ModelProperty } from 'models/Model';


export class OrderCancellationModel extends Model<OrderCancellationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'orderCancellation.property.id', isHidden: true },
		{ name: 'orderId', type: 'guid', languageString: 'orderCancellation.property.orderId' },
		{ name: 'comment', type: 'string', languageString: 'orderCancellation.property.comment' },
		{ name: 'created', type: 'Date', languageString: 'orderCancellation.property.created', isHidden: true },
		{ name: 'createdById', type: 'guid', languageString: 'orderCancellation.property.createdById' },
		{ name: 'reasonId', type: 'guid', languageString: 'orderCancellation.property.reasonId' },
		{ name: 'order', type: 'OrderModel', languageString: 'orderCancellation.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'reason', type: 'ReasonModel', languageString: 'orderCancellation.property.reason', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public comment: string;
	public created?: Date;
	public createdById?: string;
	public reasonId?: string;
	public order?: OrderModel;
	public reason?: ReasonModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.comment = '';
		this.created = undefined;
		this.createdById = undefined;
		this.reasonId = undefined;
		this.order = undefined;
		this.reason = undefined;
		
	}
	getProperties(){
		return OrderCancellationModel.classProperties;
	}
}

